import { Field } from "formik";
import { registerWidget } from "./registry";

export const RadioFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  return (
    <div style={{ margin: "10px 0px" }}>
      <Field
        {...extraProps}
        key={config.key ?? config.name}
        name={config.name}
        type={"choice"}
        role="group"
        ariaLabel="Basic radio toggle button group"
        id={config.name}
        as="div">
        {config.options.map((x: any, i: number) => (<>
          <input className="form-check form-check-input form-check-none" id={`${config.name}-btnradio${i}`} type="radio" name={config.name} value={x.key ?? x.text} />
          <label className="form-check-label" htmlFor={`${config.name}-btnradio${i}`}>{x.text ?? x.key}</label><br /></>))}
      </Field>
    </div>
  );
};

registerWidget("radio", RadioFormField);
